"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortBy = void 0;
const sort_by_1 = require("../sort-by");
exports.sortBy = (values, iteratees) => sort_by_1.sortBy([...values], iteratees);
//# sourceMappingURL=sort-by.js.map